import React from "react"
import { Link } from "react-router-dom"
import { Grid, Typography } from "@mui/material"
import { LoginLinkStyles } from "./styles/LoginPromptStyles"

function LoginPrompt() {

    return (
        <Grid container justifyContent="center">
            <Typography variant="h4">
                Please{" "}
                <Link to={"/"} sx={LoginLinkStyles}>
                    Login
                </Link>{" "}
                to view this page
            </Typography>
        </Grid>
    )
}

export default LoginPrompt
